import Typography from "@nodes/@material-ui/core/Typography";
import Divider from "@nodes/@material-ui/core/Divider";
import Button from "@nodes/@material-ui/core/Button";
import Box from "@nodes/@material-ui/core/Box";
import Card from "@nodes/@material-ui/core/Card";
import { Link } from "@nodes/react-router-dom";
import { AiFillUnlock } from "@nodes/react-icons/ai";
// import RenderRoutesBalance from "../components/RenderRoutesBalance";
import RenderBankAccounts from "../components/RenderBankAccounts";
import RenderContactInfo from "../components/RenderContactInfo";
import useMediaQuery from "../hooks/useMediaQuery";

// `customer_id` is optional: without it the self-unblock button is left out. The
// /customer/unblock/:id route only exists in the central app, and the Drawer banner that
// normally carries this call to action is dismissible, so on a blocked page it can be the
// only way left to reach it.
const RenderDisabledCustomer = ({ bankInformation, customer_id }) => {
  const fullScreen = useMediaQuery("min-width:820px");

  // Sits directly under the intro line of the payment options, so the way out of the
  // block is the first thing offered rather than something below the bank details.
  const unblockButton = customer_id ? (
    <Box mb={3}>
      <Button
        fullWidth
        size="large"
        variant="contained"
        color="primary"
        startIcon={<AiFillUnlock size="1.3em" />}
        component={Link}
        to={`/customer/unblock/${customer_id}`}
        style={{ paddingTop: 12, paddingBottom: 12, fontWeight: 600, boxShadow: "0 3px 10px rgba(0,0,0,.2)" }}>
        Desblocquear Cuenta
      </Button>
    </Box>
  ) : null;

  return (
    <div className="container mt-3 mb-5">
      <Typography variant="h4" align="center">
        Atención!
      </Typography>

      <div className="mt-2 mb-3">
        <Divider />
        <Divider />
      </div>

      <Typography variant="subtitle1" gutterBottom>
        <b> Cuenta desabilitada por falta de Pagos.</b>
      </Typography>

      <Typography variant="body1" paragraph>
        Para aceder a su ruta debe ponerse al dia con sus pagos.
      </Typography>

      {/* <RenderRoutesBalance userRoutesBalance={state.userRoutesBalance} /> */}

      <RenderBankAccounts bank={bankInformation} action={unblockButton} />

      <Card variant="outlined">
        <Box m={2}>
          <RenderContactInfo />
        </Box>
      </Card>

      {/* <Box component="div" p={2}>
        <Link to={`/customer/balance/${}/1`}>
          <Button fullWidth={!fullScreen} variant="outlined" color="primary">
            Volver Atras
          </Button>
        </Link>
      </Box> */}
    </div>
  );
};

export default RenderDisabledCustomer;
